import axios, { AxiosResponse } from 'axios';

// API URL priority:
// 1. URL parameter (?api=https://tunnel-url.trycloudflare.com)
// 2. Environment variable (REACT_APP_API_URL)
// 3. Default: /api in production, localhost:4000 in dev
const isDev = process.env.NODE_ENV !== 'production';
const urlParams = new URLSearchParams(window.location.search);
const apiFromUrl = urlParams.get('api');

const baseURL = apiFromUrl ||
  process.env.REACT_APP_API_URL ||
  (isDev ? 'http://localhost:4000' : '/api');

// Log which mode we're in on startup
const apiSource = apiFromUrl ? 'URL param' : (process.env.REACT_APP_API_URL ? 'env var' : 'default');
console.log(`[API] Mode: ${isDev ? 'DEVELOPMENT' : 'PRODUCTION'}, baseURL: ${baseURL} (${apiSource})`);

const api = axios.create({
  baseURL,
  timeout: 5000, // 5 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchData = async (endpoint: string) => {
  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error: any) {
    if (error.code === 'ECONNREFUSED' || error.code === 'ERR_NETWORK') {
      console.error(`[API] Cannot connect to backend at ${baseURL}. Is the controller running?`);
    } else {
      console.error('GET API Error:', error.message || error);
    }
    throw error;
  }
};

export const updateData = async (endpoint: string, data: any): Promise<AxiosResponse> => {
  try {
    const response = await api.put(endpoint, data);
    return response;
  } catch (error) {
    console.error('PUT API Error:', error);
    throw error;
  }
};

export const postData = async (endpoint: string, data?: any): Promise<AxiosResponse> => {
  try {
    const response = await api.post(endpoint, data);
    return response;
  } catch (error) {
    console.error('POST API Error:', error);
    throw error;
  }
};

export const deleteData = async (endpoint: string): Promise<AxiosResponse> => {
  try {
    const response = await api.delete(endpoint);
    return response;
  } catch (error) {
    console.error('DELETE API Error:', error);
    throw error;
  }
};
